import { extractDomain } from '@/utils/url.util';

const S3_ENDPOINT = import.meta.env.VITE_PUBLIC_AWS_S3_END_POINT;
const S3_BUCKET_NAME = import.meta.env.VITE_PUBLIC_AWS_S3_BUCKET_NAME;
export const IMAGE_BASE_URL = `https://${S3_BUCKET_NAME}.${extractDomain(S3_ENDPOINT)}/`;
export const IMAGE_THUMBNAIL_URL_MEDIUM = IMAGE_BASE_URL + 'thumbnails/medium/';
export const IMAGE_THUMBNAIL_URL_SMALL = IMAGE_BASE_URL + 'thumbnails/small/';

export const IMAGE_AVATAR_URL = IMAGE_BASE_URL + 'avatars/';

export enum FILE_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
}

export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff', 'ico'];
export const VIDEO_EXTENSIONS = ['mp4', 'webm', 'mov', 'avi', 'mkv', 'flv', '3gp', 'wmv'];
